import { Heading, Section } from "@carbon/react";
import { FC } from "react";

import WidgetHeaderAction from "./WidgetHeaderAction";

export type TopLabel = {
  label: string;
  value: string;
};
export type Action = {
  code: string;
  label: string;
};
export type WidgetHeaderProps = {
  title: string;
  description?: string;
  actions?: Action[];
  elementCode?: string;
  itemId?: string;
  topLabel?: TopLabel;
};

const WidgetHeader: FC<WidgetHeaderProps> = ({
  title,
  description,
  elementCode,
  itemId,
  actions,
  topLabel,
}) => {
  return (
    <div>
      <Section level={4} className="flex items-center justify-between">
        <Heading>{title}</Heading>
        {actions && elementCode && topLabel && itemId && (
          <WidgetHeaderAction
            actions={actions}
            elementCode={elementCode}
            itemId={itemId}
            topLabel={topLabel}
          />
        )}
      </Section>
      <div>{description && <p className="text-textSecondary line-clamp-2">{description}</p>}</div>
    </div>
  );
};

export default WidgetHeader;
